var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoplar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 473.214 473.214",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 473.214 473.214",
    stroke: "#000000",
    strokeWidth: 14.19642,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m243.144,5.646l-6.538-5.646-6.537,5.646c-84.376,72.884-137.583,139.293-158.141,197.385-17.205,48.616-12.192,92.013 14.897,128.987 23.108,31.54 48.903,46.871 78.861,46.87 15.367-0.001 29.825-3.92 42.58-7.377 6.411-1.737 12.601-3.414 18.341-4.438v106.141h20v-106.141c5.739,1.024 11.928,2.701 18.337,4.438 12.756,3.458 27.214,7.377 42.584,7.377 29.957,0 55.753-15.331 78.86-46.87 27.09-36.974 32.103-80.372 14.897-128.987-20.558-58.092-73.765-124.501-158.141-197.385zm127.112,314.552c-25.409,34.679-47.969,38.69-62.728,38.69-12.708,0-25.235-3.396-37.351-6.679-8.111-2.199-15.909-4.311-23.57-5.394v-34.378l45.125-47.508-14.502-13.774-30.623,32.24v-61.519l45.125-47.507-14.502-13.773-30.623,32.24v-54.852h-20v54.852l-30.622-32.24-14.502,13.773 45.124,47.507v61.518l-30.622-32.24-14.502,13.774 45.124,47.507v34.378c-7.661,1.084-15.46,3.195-23.572,5.394-12.116,3.284-24.645,6.68-37.35,6.68-14.759,0-37.317-4.01-62.727-38.69-22.944-31.316-27.041-68.492-12.176-110.495 18.863-53.301 67.905-114.918 145.824-183.234 77.919,68.315 126.962,129.933 145.825,183.234 14.866,42.004 10.769,79.18-12.175,110.496z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoplar);
export default __webpack_public_path__ + "static/media/poplar.2e0b483168923293207bcbc901caa79a.svg";
export { ForwardRef as ReactComponent };